module.exports = __webpack_public_path__ + "static/media/automation.ca867ce9.svg";